import * as React from 'react'
// components
import Tooltip from '@mui/material/Tooltip'
// views
import { Button, ButtonsWrapper, CopyIcon, LinkIcon } from './views'

interface Props {
  copyOnly?: boolean
  currentAction: 'copy' | 'reference' | null
  onButtonClick: (action: 'copy' | 'reference') => void
}

const Control: React.FC<Props> = ({ copyOnly, currentAction, onButtonClick }) => {
  return (
    <ButtonsWrapper>
      <Button onClick={() => onButtonClick('copy')}>
        <Tooltip title='Copy' placement='top-start'>
          <CopyIcon active={currentAction === 'copy'} />
        </Tooltip>
      </Button>
      {!copyOnly && (
        <Button onClick={() => onButtonClick('reference')}>
          <Tooltip title='Reference' placement='top-start'>
            <LinkIcon active={currentAction === 'reference'} />
          </Tooltip>
        </Button>
      )}
    </ButtonsWrapper>
  )
}

export default Control
